import { render, staticRenderFns } from "./ForgotPasswordSendOTP.vue?vue&type=template&id=84b5635e&scoped=true"
import script from "./ForgotPasswordSendOTP.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSendOTP.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordSendOTP.vue?vue&type=style&index=0&id=84b5635e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b5635e",
  null
  
)

export default component.exports